/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2018 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the property of
 * Pearson Education, Inc. The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S.
 * and Foreign Patents, patent applications, and are protected by trade secret
 * or copyright law. Dissemination of this information, reproduction of this
 * material, and copying or distribution of this software is strictly forbidden
 * unless prior written permission is obtained from Pearson Education, Inc.
 */
import { cloneDeep } from 'lodash';

import {
    GET_BOOK_BUILD_STATUS, CLEAR_BOOK_BUILD_STATUS
} from '../_actions/collection.actions';

export const INITIAL_STATE = {
};

export function bookBuildReducer (state = INITIAL_STATE, action) {
    switch (action.type) {
        case GET_BOOK_BUILD_STATUS: {
            return action.payload;
        }
        case CLEAR_BOOK_BUILD_STATUS: {
            return{...state, rebuildBookComplete: false};
        }
        default: {
            return state;
        }
    }
}



// WEBPACK FOOTER //
// ./src/_reducers/book.build.reducer.js